import { countBy } from "@lyfegen-platform/utils";
import { IconButton, Typography } from "@material-ui/core";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import QuestionAnswerOutlinedIcon from "@material-ui/icons/QuestionAnswerOutlined";
import { FC } from "react";
import { useDocumentContext } from "../invoices/DocumentContextProvider";
import useMessagesStyles from "./use-messages-styles";

export const InvokeCommentsButton: FC<{ agreementId?: string; caseId?: string; refundId?: string; style?: { marginRight?: number } }> = ({
	agreementId,
	caseId,
	refundId,
	style,
}) => {
	const { messages, messagingDispatcher } = useDocumentContext();
	const { icon } = useMessagesStyles();

	const getCount = () => {
		return countBy(
			messages,
			(m) =>
				(!agreementId || m.agreementIds.includes(agreementId)) &&
				(!caseId || m.cases.some((c) => c.id === caseId)) &&
				(!refundId || m.refunds.some((r) => r.id === refundId)),
			true
		);
	};

	const count = getCount();
	const MessageIcon = count > 0 ? QuestionAnswerIcon : QuestionAnswerOutlinedIcon;

	const handleClick = () => {
		messagingDispatcher({
			type: "open-drawer",
			...((refundId && { refundIds: [refundId] }) ||
				(caseId && { caseIds: [caseId] }) ||
				(agreementId && { agreementIds: [agreementId] })),
		});
	};

	return (
		<IconButton disableTouchRipple onClick={handleClick} classes={{ root: icon }} style={{ paddingRight: 0, ...style }}>
			<div style={{ gap: 5, display: "flex" }}>
				<MessageIcon color="primary" />
				{!count ? (
					<Typography color="textSecondary">0</Typography>
				) : (
					<Typography color="primary" variant="body1">
						{count}
					</Typography>
				)}
			</div>
		</IconButton>
	);
};
